import { render, staticRenderFns } from "./VecdynDatasets.vue?vue&type=template&id=9cb93674&scoped=true&"
import script from "./VecdynDatasets.vue?vue&type=script&lang=js&"
export * from "./VecdynDatasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb93674",
  null
  
)

export default component.exports